import React from 'react';
import { List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import {
    ClipboardTextOutline,
    CheckCircleOutline,
    HelpCircleOutline,
    CommentTextOutline,
} from 'mdi-material-ui';
import { texts } from 'utils/languages/fr';
import PropTypes from 'prop-types';

const nestedListSx = {
    pl: 4,
};
const phaseItemSx = {
    fontWeight: 'bold',
    borderBottom: '1px solid',
};

const stepItemSx = {
    borderLeft: '3px solid',
    borderRadius: 1,
    mb: 1,
    mt: 1,
};

const Phases = ({ tunnel }) => (
    <List component="nav">
        {tunnel.phases.map((phase, phaseIndex) => (
            <React.Fragment key={phaseIndex}>
                <ListItem sx={phaseItemSx}>
                    <ListItemIcon>
                        <ClipboardTextOutline color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        primary={phase.name}
                        primaryTypographyProps={{ variant: 'subtitle1' }}
                    />
                </ListItem>
                <List component="div" sx={nestedListSx}>
                    {phase.steps.map((step, stepIndex) => (
                        <React.Fragment key={stepIndex}>
                            <ListItem sx={stepItemSx}>
                                <ListItemIcon>
                                    <CheckCircleOutline color="primary" />
                                </ListItemIcon>
                                <ListItemText
                                    primary={`${step.name}${
                                        step.mandatory === false
                                            ? ` (${texts.OPTIONAL.toLowerCase()})`
                                            : ''
                                    }`}
                                />
                            </ListItem>
                            {step.questions.length > 0 && (
                                <List component="div" sx={nestedListSx}>
                                    {step.questions.map((question, questionIndex) => (
                                        <React.Fragment key={questionIndex}>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <HelpCircleOutline color="info" />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={`${texts.QUESTION_TEXT}: ${question.title}`}
                                                />
                                            </ListItem>
                                            <List component="div" sx={nestedListSx}>
                                                {question.answers.map((answer, answerIndex) => (
                                                    <ListItem key={answerIndex}>
                                                        <ListItemIcon>
                                                            <CommentTextOutline color="action" />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={`${texts.ANSWER_TEXT}: ${answer.title}`}
                                                            secondary={`${texts.ANSWER_SCORE}: ${answer.score}`}
                                                        />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </React.Fragment>
                                    ))}
                                </List>
                            )}
                        </React.Fragment>
                    ))}
                </List>
            </React.Fragment>
        ))}
    </List>
);

Phases.propTypes = {
    tunnel: PropTypes.shape({
        phases: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                steps: PropTypes.arrayOf(
                    PropTypes.shape({
                        name: PropTypes.string,
                        mandatory: PropTypes.bool,
                        questions: PropTypes.arrayOf(
                            PropTypes.shape({
                                title: PropTypes.string,
                                answers: PropTypes.arrayOf(
                                    PropTypes.shape({
                                        title: PropTypes.string,
                                        score: PropTypes.number,
                                    })
                                ),
                            })
                        ),
                    })
                ),
            })
        ),
    }),
};

export default Phases;
